/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BigCommerceCustomerGroupRef } from "./BigCommerceCustomerGroupRef";
import {
  BigCommerceCustomerGroupRefFromJSON,
  BigCommerceCustomerGroupRefFromJSONTyped,
  BigCommerceCustomerGroupRefToJSON,
  BigCommerceCustomerGroupRefToJSONTyped,
} from "./BigCommerceCustomerGroupRef";

/**
 *
 * @export
 * @interface BigCommerceGroupLocationTypeRule
 */
export interface BigCommerceGroupLocationTypeRule {
  /**
   *
   * @type {Array<BigCommerceCustomerGroupRef>}
   * @memberof BigCommerceGroupLocationTypeRule
   */
  customerGroups: Array<BigCommerceCustomerGroupRef>;
  /**
   *
   * @type {string}
   * @memberof BigCommerceGroupLocationTypeRule
   */
  locationType: string;
  /**
   *
   * @type {string}
   * @memberof BigCommerceGroupLocationTypeRule
   */
  distributionWarehouseBrand?: string | null;
}

/**
 * Check if a given object implements the BigCommerceGroupLocationTypeRule interface.
 */
export function instanceOfBigCommerceGroupLocationTypeRule(
  value: object,
): value is BigCommerceGroupLocationTypeRule {
  if (!("customerGroups" in value) || value["customerGroups"] === undefined)
    return false;
  if (!("locationType" in value) || value["locationType"] === undefined)
    return false;
  return true;
}

export function BigCommerceGroupLocationTypeRuleFromJSON(
  json: any,
): BigCommerceGroupLocationTypeRule {
  return BigCommerceGroupLocationTypeRuleFromJSONTyped(json, false);
}

export function BigCommerceGroupLocationTypeRuleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceGroupLocationTypeRule {
  if (json == null) {
    return json;
  }
  return {
    customerGroups: (json["customerGroups"] as Array<any>).map(
      BigCommerceCustomerGroupRefFromJSON,
    ),
    locationType: json["locationType"],
    distributionWarehouseBrand:
      json["distributionWarehouseBrand"] == null
        ? undefined
        : json["distributionWarehouseBrand"],
  };
}

export function BigCommerceGroupLocationTypeRuleToJSON(
  json: any,
): BigCommerceGroupLocationTypeRule {
  return BigCommerceGroupLocationTypeRuleToJSONTyped(json, false);
}

export function BigCommerceGroupLocationTypeRuleToJSONTyped(
  value?: BigCommerceGroupLocationTypeRule | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customerGroups: (value["customerGroups"] as Array<any>).map(
      BigCommerceCustomerGroupRefToJSON,
    ),
    locationType: value["locationType"],
    distributionWarehouseBrand: value["distributionWarehouseBrand"],
  };
}
